import { fmeaComponentTemplatesService } from './fmeaComponentTemplates.service';

export const fmeaComponentTemplatesConstants = {
  LIST_REQUEST: 'FMEA_COMPONENT_TEMPLATES_LIST_REQUEST',
  LIST_SUCCESS: 'FMEA_COMPONENT_TEMPLATES_LIST_SUCCESS',
  LIST_FAILURE: 'FMEA_COMPONENT_TEMPLATES_LIST_FAILURE',
  UPDATE_SUCCESS: 'FMEA_COMPONENT_TEMPLATES_UPDATE_SUCCESS',
  DELETE_SUCCESS: 'FMEA_COMPONENT_TEMPLATES_DELETE_SUCCESS',
};

export const listFmeaComponentTemplates = params => (dispatch) => {
  dispatch({ type: fmeaComponentTemplatesConstants.LIST_REQUEST });
  return fmeaComponentTemplatesService.listTemplates(params).then(
    (data) => {
      dispatch({ type: fmeaComponentTemplatesConstants.LIST_SUCCESS, data });
      return data;
    },
    (error) => {
      dispatch({ type: fmeaComponentTemplatesConstants.LIST_FAILURE, error });
    }
  );
};
